import { Component, OnInit } from '@angular/core';

import { MatAccordion } from '@angular/material'
import { TokenStorage } from '../../auth/token.storage';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  isBajaj: boolean = false;
  isTenantDiag: boolean = false;
  isKohinoor: boolean = false;
  isVijaya: boolean = false;
  constructor(private token: TokenStorage,
  ) {
    if (this.token.getTenant() === 'bajaj-reta-prod' || this.token.getTenant() === 'bajaj-reta-test') {
      this.isBajaj = true;
    }

    if (this.token.getTenant() === 'kohinoor-reta-prod' || this.token.getTenant() === 'kohinoor-reta-test') {
      this.isKohinoor = true;
    }

    if (this.token.getTenant() === 'vijaya-reta-prod') {
      this.isVijaya = true;
    }

    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
    }
  }

  ngOnInit() {
  }

}
